import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./OtpVerify.css";
import logo from "../../../Assets/Images/logo.png";
import { MAIN_URL } from "../../../Configurations/Urls";

const SpinSVG = () => (
  <svg width="18" height="18" viewBox="0 0 15 15" fill="none"
    style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}>
    <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor" strokeOpacity=".3" strokeWidth="2.5" fill="none" />
    <path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
  </svg>
);

const OtpVerify = ({ title = "Email Verification" }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'error'
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  const appName = "HR ERP";
  const description =
    "Start your free trial and experience the full power of our platform today.";

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    } else {
      setMessage("Email not provided.");
      setMessageType("error");
    }
  }, [location.state]);

  console.log("state", location.state);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");

    if (enteredOtp?.length < 6) {
      setMessage("Please enter the complete 6-digit OTP.");
      setMessageType("error");
      return;
    }

    if (!email) {
      setMessage("Email is missing.");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await axios.post(`${MAIN_URL}/api/auth/verified-otp`, {
        email: location.state.email,
        otp: +enteredOtp,
      });
      setMessage("OTP Verified successfully!");
      setMessageType("success");

      const data = await axios.post(
        `${MAIN_URL}/api/application/user/create-userV1`,
        {
          hash_password: location.state.hash_password,
          full_name: location.state.full_name,
          phone_number: location.state.phone,
          country_phone_code: location.state.phone_code,
          email: location.state.email,
        }
      );

      setMessage("Account created successfully!");
      setMessageType("success");
      
     
    //  console.log(location.state.hash_password)

      navigate("/organization-details", {
      state: { application_user_id: data.data.data.application_users_id ,
        hash_password:location.state.hash_password,
        email: location.state.email,
      },
      });
    } catch (error) {

      console.log("error is",error)
      setMessage("Invalid OTP or verification failed. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ems-auth-root">

      <div className="ems-auth-left">
        <div className="ems-auth-card">

          <div className="ems-auth-brand">
            <img src={logo} alt="HR ERP" className="ems-auth-brand-logo" />
          </div>

          <h1 className="ems-auth-h">{title}</h1>
          <p className="ems-auth-sub">Enter the 6-digit OTP sent to your email</p>

          <form onSubmit={handleSubmit} className="otp-form" noValidate>
            <div className="ems-auth-field">
              <label>Verification Code</label>
              <div className="otp-inputs" style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className="otp-input ems-fm-input text-center"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    style={{
                      width: "44px",
                      height: "50px",
                      fontSize: "1.5rem",
                      padding: 0,
                      textAlign: "center",
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="ems-auth-actions">
              <button type="submit" className="ems-btn ems-primary" disabled={loading}>
                {loading ? <><SpinSVG /> Verifying…</> : "Verify OTP"}
              </button>
            </div>
          </form>

          {message && (
            <p
              className={`otp-message ${messageType === "success" ? "ems-fm-ok" : "ems-fm-err"}`}
              style={{ marginTop: 16, fontSize: 13, fontWeight: 600 }}
            >
              {message}
            </p>
          )}

        </div>
      </div>

      <div className="ems-auth-right">
        <div className="ems-auth-hero">
          <div className="ems-auth-hero-mark">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path d="M5 8h16M5 13h10M5 18h16" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h2 className="ems-auth-hero-h">{appName}</h2>
          <p className="ems-auth-hero-p">{description}</p>
          <div className="ems-auth-trust">
            <span className="ems-auth-trust-dot" />
            Join thousands of happy users.
          </div>
        </div>
        <p className="ems-auth-copy">&copy; {new Date().getFullYear()} {appName}. All rights reserved.</p>
      </div>

    </div>
  );
};

export default OtpVerify;
